<template>
  <div class="container-fluid">

    <!-- Cargando -->
    <div v-if="loading" class="text-center py-5">
      <div class="loader-box">
        <div class="loader-3"></div>
      </div>
      <p>Cargando...</p>
    </div>

    <!-- Error -->
    <div v-else-if="error" class="text-center py-5">
      <div class="alert alert-danger">
        <h5>Error al cargar el artículo</h5>
        <p>{{ error.message || 'Ocurrió un error inesperado' }}</p>
        <button class="btn btn-secondary me-2" @click="$router.back()">
          <i class="fa fa-arrow-left"></i> Regresar
        </button>
        <button class="btn btn-primary" @click="fetchPost()">Reintentar</button>
      </div>
    </div>

    <!-- Contenido -->
    <div v-else-if="post">

      <!-- Encabezado de página -->
      <div class="page-title">
        <div class="row align-items-center">
          <div class="col-12 d-flex align-items-center gap-3">
            <button class="btn btn-outline-secondary btn-sm" @click="$router.back()">
              <i class="fa fa-arrow-left"></i> Regresar
            </button>
            <h3 class="mb-0">{{ post.title }}</h3>
          </div>
        </div>
      </div>

      <!-- Artículo de blog -->
      <div class="row justify-content-center">
        <div class="col-lg-11 col-md-11 col-12">
          <div class="card">

            <!-- Imagen de portada -->
            <div v-if="post.thumbnail_rendition" class="card-header p-0" style="overflow: hidden; border-radius: 15px 15px 0 0;">
              <img
                :src="coverImageUrl"
                :alt="post.thumbnail_rendition.alt || post.title"
                style="width: 100%; max-height: 360px; object-fit: cover;"
              />
            </div>

            <div class="card-body p-4 p-md-5">

              <!-- Meta del artículo -->
              <div class="d-flex flex-wrap align-items-center gap-3 mb-4 pb-3 border-bottom">
                <span v-if="publishedAt" class="text-muted small">
                  <i class="fa fa-calendar me-1"></i> {{ publishedAt }}
                </span>
                <span v-if="post.intro && post.intro !== post.title" class="text-muted small">
                  <i class="fa fa-tag me-1"></i> {{ post.intro }}
                </span>
              </div>

              <!-- Cuerpo del artículo -->
              <div class="post-body" v-html="resolvedBody || post.body"></div>

              <!-- Footer del post -->
              <div v-if="post.footer" class="mt-4 pt-3 border-top text-muted">
                <p class="mb-0">Para mayor información <span v-html="post.footer"></span></p>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from "@/axios";

const BASE = 'https://rverdeadmin.klatus.systems';

export default {
  name: "detallePost",
  data() {
    return {
      post: null,
      resolvedBody: null,
      loading: true,
      error: null,
    };
  },
  created() {
    this.fetchPost();
  },
  computed: {
    publishedAt() {
      const d = this.post?.meta?.first_published_at;
      return d ? new Date(d).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : null;
    },
    coverImageUrl() {
      const r = this.post?.thumbnail_rendition;
      if (!r) return null;
      const url = r.full_url || r.url || '';
      return url.startsWith('http') ? url : `${BASE}${url}`;
    },
  },
  methods: {
    async fetchPost() {
      this.loading = true;
      this.error = null;
      try {
        const { id } = this.$route.params;
        const { data } = await api.get(`pages/${id}/?fields=intro,body,thumbnail,thumbnail_rendition,footer,title`);
        this.post = data;
        this.resolvedBody = await this.resolveBodyImages(data.body);
      } catch (err) {
        this.error = err;
        console.error('Error al cargar post:', err);
      } finally {
        this.loading = false;
      }
    },
    async resolveBodyImages(html) {
      if (!html) return html;
      const ids = new Set();
      const re = /<embed[^>]*embedtype="image"[^>]*id="(\d+)"[^>]*/gi;
      let match;
      while ((match = re.exec(html)) !== null) ids.add(match[1]);
      if (!ids.size) return html;

      const imageMap = {};
      await Promise.all([...ids].map(async (id) => {
        try {
          const { data } = await api.get(`images/${id}/`);
          imageMap[id] = data;
        } catch (e) {
          console.warn(`No se pudo cargar imagen ID ${id}`, e);
        }
      }));

      return html.replace(/<embed([^>]*)\/?>(?:<\/embed>)?/gi, (fullMatch, attrs) => {
        if (!/embedtype="image"/i.test(attrs)) return fullMatch;
        const idMatch  = /\bid="(\d+)"/i.exec(attrs);
        const altMatch = /\balt="([^"]*)"/i.exec(attrs);
        const fmtMatch = /\bformat="([^"]*)"/i.exec(attrs);
        if (!idMatch) return fullMatch;
        const img = imageMap[idMatch[1]];
        if (!img) return '';
        const rawUrl = img.meta?.download_url || img.url || '';
        const url = rawUrl.startsWith('http') ? rawUrl : `${BASE}${rawUrl}`;
        const alt = altMatch ? altMatch[1] : (img.title || '');
        const format = fmtMatch ? fmtMatch[1] : 'fullwidth';
        const alignClass = format === 'left' ? 'float-start me-3' : format === 'right' ? 'float-end ms-3' : 'd-block mx-auto';
        return `<img src="${url}" alt="${alt}" class="img-fluid d-block mx-auto mb-3" style="max-width: 100%;" />`;
      });
    },
  },
};
</script>


